export default __webpack_public_path__ + "static/media/Info.ee9eb05e.svg";